import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

interface ErrorMessageProps {
  className?: string;
  message: string;
}

export default function ErrorMessage({
  className,
  message,
}: ErrorMessageProps) {
  return (
    <div
      className={classNames(
        'bg-negative-red bg-opacity-10 border-l-4 border-negative-red p-4 rounded-md',
        className
      )}
    >
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <FontAwesomeIcon
            icon={['far', 'exclamation-triangle']}
            className="text-lg text-negative-red"
          />
        </div>
        <div className="ml-3">
          <p
            role="alert"
            className="text-base font-avenir-medium text-negative-red"
          >
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
